import { render, staticRenderFns } from "./tileTop.vue?vue&type=template&id=35b825f0&scoped=true&"
import script from "./tileTop.vue?vue&type=script&lang=js&"
export * from "./tileTop.vue?vue&type=script&lang=js&"
import style0 from "./tileTop.vue?vue&type=style&index=0&id=35b825f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b825f0",
  null
  
)

export default component.exports